<template>
  <div class="more-table">
    <el-table :data="data">
      <el-table-column
        label="操作"
        fixed="left"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="deleteRow(scope.$index)"
            type="text"
            size="small"
          >删除
          </el-button>
        </template>
      </el-table-column>
      索引
      <el-table-column
        align="center"
        type="index"
        width="60"
        label="序号"
      ></el-table-column>
      <el-table-column
        :property="column.prop"
        :label="column.label"
        :align="column.align"
        :width="column.width"
        v-for="(column,index) in tableColumns"
        :key="index"
      >
        <template slot-scope="scope">
          <el-input
            v-model="scope.row[column.prop]"
            v-if="column.type=='input'"
            :disabled="column.disabled || false"
          ></el-input>
          <el-input-number
            v-model="scope.row[column.prop]"
            v-else-if="column.type=='inputNumber'"
            :disabled="column.disabled || false"
            :precision="column.precision||undefined"
          ></el-input-number>
          <template v-else-if="column.type=='image'">
            <img
              class="table-img"
              :src="scope.row[column.prop]"
              v-if="scope.row[column.prop]"
            />
            <a
              v-else
              @click="addImage(scope.$index)"
            >上传图片</a>
          </template>
          <span v-else>{{scope.row[column.prop]}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

import api from "@/config/api";
import COS from "cos-js-sdk-v5";
export default {
  props: {
    tableColumns: {
      type: Array,
    },
    data: {
      type: Array,
    },
  },
  data(){
    return {
        fileType:[],
        cos: null,
        fileList: []
    }
  },
  created(){
    this.fileInit();
  },
  methods: {
    deleteRow(index) {
      this.$emit("deleteRow", index);
    },
    addImage(index) {
      this.$utils.uploadFile((file, index) => {
        this.uploadFile(file,index)
      }, index);
    },
    //上传文件初始化
    fileInit() {
      this.cos = new COS({
        getAuthorization: (options, callback) => {
          this.$axios.fetchPost(api.sign + "?method=POST").then((result) => {
            let credentials = result.data && result.data.credentials;
            if (!result.data || !credentials) {
              this.fileList.pop();
              this.$message.error("cos签名错误");
              return console.error("credentials invalid");
            }
            callback({
              TmpSecretId: credentials.tmpSecretId,
              TmpSecretKey: credentials.tmpSecretKey,
              XCosSecurityToken: credentials.sessionToken,
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: result.data.startTime, // 时间戳，单位秒，如：1580000000
              ExpiredTime: result.data.expiredTime, // 时间戳，单位秒，如：1580000900
              ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
            });
          });
        },
      });
    },
     //文件上传
      uploadFile(file,index) {
        this.cos.putObject({
          Bucket: this.$utils.cos.bucket,
          Region: this.$utils.cos.region,
          Key: file.name,
          Body: file,
          onProgress: (progressData)=> {

          }
        }, (err, data)=>{
          if (data && data.Location) {
            this.$emit("addImage", 'https://'+data.Location, index);
          } else {
            params.onError(err)
          }
        });
      },
  },
};
</script>
<style >
.more-table .el-table th,
.more-table .el-table tr {
  line-height: 33px;
  height:33px;
}
.more-table .el-table__row .cell{
  line-height: 33px;
  height:33px;
}
</style>



// WEBPACK FOOTER //
// src/components/business/moreTable.vue